<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import Vue from 'vue'

import {deviceApi} from '@router/apiFiles/deviceApi'

export default {
  page: {
    title: 'Telemetry search',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      tableData: [],
      isBusy: true,
      title: 'Telemetry search',
      items: [
        {
          text: 'OnBoard',
          href: '/',
        },
        {
          text: 'Devices',
          href: '/',
        },
        {
          text: 'Telemetry search',
          active: true,
        },
      ],
      filter: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 25, 50, 100, 150],
      dateStart: '',
      dateEnd: '',
      fields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'dateTime', label: 'Date/Time', sortable: false},
        {key: 'lat', label: 'Lat', sortable: false},
        {key: 'lng', label: 'Lng', sortable: false},
        'link',
        {key: 'kmh', label: 'km/h', sortable: false},
        {key: 'acc', label: 'Acc', sortable: false},
        {key: 'isOn', label: 'IsOn', sortable: false},
        {key: 'data', label: 'Data', sortable: false},
      ],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  mounted() {
    const today = new Date()
    const startDate = new Date(today)
    startDate.setDate(startDate.getDate() - 3)
    this.dateStart = startDate
    this.dateEnd = new Date(today)
    this.fetchData().catch(error => {
      console.error(error)
    })
  },
  methods: {

    onFiltered(filteredItems) {
    },
    formatDateForApi(dateVal) {
      if (!dateVal) return ''
      const d = dateVal instanceof Date ? dateVal : new Date(dateVal)
      return isNaN(d.getTime()) ? '' : d.toISOString()
    },
    async fetchData() {
      var self = this;
      self.currentPage = 1;
      deviceApi.searchTelemetry({
        deviceId: self.$route.params.id,
        page: self.currentPage,
        perPage: self.perPage,
        start: self.formatDateForApi(self.dateStart),
        end: self.formatDateForApi(self.dateEnd)
      })
          .then(function (data) {
            self.tableData = data.data;
            self.isBusy = false;
            self.totalRows = data.data.length;
          });
    },
    loadMore() {
      var self = this;
      self.currentPage++;
      deviceApi.searchTelemetry({
        deviceId: self.$route.params.id,
        page: self.currentPage,
        perPage: self.perPage,
        start: self.formatDateForApi(self.dateStart),
        end: self.formatDateForApi(self.dateEnd)
      })
          .then(function (data) {
            self.tableData = self.tableData.concat(data.data);
            self.isBusy = false;
            self.totalRows = data.data.length;
          });
    }
  },
  watch: {
    perPage: {
      handler: function (value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-4"></p>
            <div class="row mb-md-2">

              <!-- beginDate -->
              <div class="col-sm-6 col-md-2">
                <div>
                  <div class="form-group form-group-sm">
                    <label>Start</label>
                    <div>
                      <flat-pickr v-model="dateStart" class="mw-100" name="dateStart"></flat-pickr>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End beginDate -->

              <!-- beginDate -->
              <div class="col-sm-6 col-md-2">
                <div>
                  <div class="form-group form-group-sm">
                    <label>End</label>
                    <div>
                      <flat-pickr v-model="dateEnd" class="mw-100" name="dateEnd"></flat-pickr>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End beginDate -->

              <div class="col-sm-2 col-md-1">
                <div>
                  <div class="form-group form-group-sm">
                    <label>Search</label>
                    <div>
                      <button class="btn btn-sm btn-info" @click="fetchData"><i class="uil uil-search "></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div id="tickets-table_length" class="dataTables_length  text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage"
                                   size="sm"
                                   :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>


            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table :items="tableData"
                       :fields="fields"
                       responsive="sm"
                       :per-page="0"
                       :current-page="currentPage"
                       :busy="isBusy">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(link)="data">
                  <a target="_blank" class="btn btn-primary btn-sm"
                     v-if="data.item.lat != null && data.item.lat != null"
                     v-bind:href="'https://www.google.com/maps/search/?api=1&query=' + data.item.lat + '%2C' + data.item.lng"><i
                      class="uil uil-map-marker"></i></a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div>
                  <button type="button" v-if="totalRows > 0" class="btn btn-sm btn-info" @click="loadMore"><i
                      class="uil uil-search"> Load More</i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
